<dx-data-grid [dataSource]='dataSourceItems'>
    <ng-container>
        <dxi-column dataField="StatusEventSubscriptionStatusTypeName" caption="Status Type" dataType="string" [visible]="true"></dxi-column>
        <dxi-column dataField="Source" caption="Source" dataType="string" [visible]="true"></dxi-column>
        <dxi-column dataField="Comment" caption="Comment" dataType="string" [visible]="true"></dxi-column>
        <dxi-column dataField="CreatedDate" caption="Log Date" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction" [visible]="true"></dxi-column>
    </ng-container>
</dx-data-grid>